














import { Component, Watch, Prop } from 'vue-property-decorator'
import ViewBase from '@/util/ViewBase'
import { ListType } from '@/util/types'
import { courseItem, resourceItem } from '@/api/res'
import { parse } from 'qs'
const echarts = require('echarts/lib/echarts')
// 引入柱状图组件
require('echarts/lib/chart/bar')
// 引入提示框和title组件
require('echarts/lib/component/tooltip')
require('echarts/lib/component/title')
require('echarts/lib/component/legend')

@Component({
  components: {}
})
export default class TestRate extends ViewBase {
  @Prop({ default: null }) ratingList!: any
  @Prop({ default: null }) stepsEntirety!: any

  lang: any = {}

  ratingData: any = []

  stepsEntiretyTitle: any = []

  stepsEntiretyData: any = []

  stepsEntiretyText: any = []

  get i18n() {
    const value = this.$t('login')
    return value as any
  }

  get isEnLang() {
    return this.$i18n.locale == 'en'
  }
  setEntryData() {
    this.stepsEntiretyTitle = []
    this.stepsEntiretyData = []
    this.stepsEntirety.forEach((element: any) => {
      this.stepsEntiretyTitle.push(element.s_name)
      this.stepsEntiretyData.push(element.num)
      this.stepsEntiretyText.push(element.cid_name_list)
    })
    this.setComplete()
  }

  setRatingData() {
    this.ratingData = []
    for (const key of Object.keys(this.ratingList)) {
      const element = this.ratingList[key]
      const obj: any = {}
      obj.name = element.level_name
      obj.value = element.rate
      obj.text = element.cid_name_list.join(',')
      this.ratingData.push(obj)
    }
    this.setRate()
  }
  // 评级分布
  setRate() {
    // 基于准备好的dom，初始化echarts实例
    const myChart = echarts.init(this.$refs.grade)
    const that = this
    const option = {
      // title: {
      //   text: '某站点用户访问来源',
      //   subtext: '纯属虚构',
      //   left: 'center'
      // },

      tooltip: {
        formatter: '{b0}: {c0}%'
      },
      legend: {
        orient: 'vertical',
        left: 'left',
        data: [
          that.lang.levelA,
          that.lang.levelB,
          that.lang.levelC,
          that.lang.levelD,
          that.lang.levelOther
        ],
        formatter: (name: any) => {
          const val = that.ratingData.filter((item: any) => {
            return item.name == name
          })
          return `${name}: ${val[0].text}`
        }
      },
      color: ['#5B9BD5', '#ED7D31', '#A5A5A5', '#FFC000', '#4472C4'],
      series: [
        {
          // name: '评级分布',
          type: 'pie',
          radius: '55%',
          center: ['50%', '60%'],
          data: that.ratingData,
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          }
        }
      ]
    }
    // 绘制图表
    myChart.setOption(option)
  }

  // 整体完成情况

  setComplete() {
    const myChart = echarts.init(this.$refs.complete)
    const that = this
    const option = {
      legend: {
        x: 'center'
      },

      tooltip: {
        trigger: 'item' /*此处为item*/,
        axisPointer: {
          type: 'line'
        },
        formatter(params: any, trigger: any) {
          const index = params.value.index
          // console.log(params)
          const textKey = params.dimensionNames[params.encode.y[0]]
          return `<div style="text-align:center">${
            that.stepsEntiretyText[params.dataIndex]
          }</div>`
        }
      },
      xAxis: [
        {
          type: 'category',
          data: that.stepsEntiretyTitle,
          axisTick: {
            alignWithLabel: true
          }
        }
      ],
      yAxis: [
        {
          type: 'value'
        }
      ],
      // Declare several bar series, each will be mapped
      // to a column of dataset.source by default.
      series: [
        {
          name: that.lang.completeNum,
          type: 'bar',
          data: that.stepsEntiretyData,
          itemStyle: {
            normal: {
              color: '#ED7D31'
            }
          }
        }
      ]
    }

    // 绘制图表
    myChart.setOption(option)
  }
  created() {
    this.lang = this.i18n.vStudy
    setTimeout(() => {
      this.setRatingData()
      this.setEntryData()
    })
  }
}
